import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
// utils
import { electOwningCase, getProjectStatus, Translations } from '../../../utils';
// restClient
import { eapiClient, aemHostClient, taxonomyHostClient } from '../../../restClient';
// children
import CaseMenu from '../../common/CaseMenu/CaseMenu';
import NavListAccordion, { NavListAccordionWrapper } from '../../common/NavListAccordion/NavListAccordion';
//action Creator
import { setDarkTitleBarContent, updateDarkTitleBarCaseStatus } from '../../layouts/actions/actionCreator';
//style
import './SupportingDoc.css';

class SupportingDoc extends Component {

  constructor(props) {
    super(props);
    this.state = {
      welcomeCase: [],
      data: [],
      owningCaseUrn: this.props.history.location.state.Urn
    };
  }

  componentWillMount() {
    var apiURL = "/aemData/formData/json_supporting-documentation";
    window.localStorage.setItem('owningCase', this.props.owningCase.caseId);
    aemHostClient(apiURL)
      .then(({ data }) => {
        document.title = `${Translations(data.par.page_title_mainTitle.pageHeading, this.props.lang.currentLang.lang, this.props.lang.translatedData)} - ${'HSBC GLCM'}`;
        this.setState({ formJson: data });
      });

    let _state = this.state;
    const url = `/cases/${this.props.match.params.Urn}/supportingDocument`;
    try {
      if (this.state.owningCaseUrn !== undefined) {
        eapiClient(url)
          .then(({ data }) => {
            _state['data'] = data.responseData.data;
            this.props.updateDarkTitleBarCaseStatus(getProjectStatus(this.props.owningCase.caseId, data.responseData.caseStatuses));
            this.setState(_state);
          });
      } else {
        _state['data'] = [];
        this.setState(_state);
      }
      let heading;
      if (Object.keys(this.props.cases).length >= 1) {
        const noOfCasesExcludingRoot = Object.keys(this.props.cases).length - 1;
        heading = `${this.props.owningCase.entityName} ${Object.keys(this.props.cases).length > 1 ? `${'('}${'+'}${noOfCasesExcludingRoot} ${'others'}${')'}` : ''}`;
      } else {
        heading = `${this.props.owningCase.entityName}`;
      }
      aemHostClient("/aemData/formData/json_dark-title-bar")
        .then(({ data, status }) => {
          taxonomyHostClient(Translations(data.par.static_text_darkTitleBar.CaseStatusapi, this.props.lang.currentLang.lang, this.props.lang.translatedData))
            .then(({ data: caseStatusApiData }) => {
              this.props.setDarkTitleBarContent(heading, true, Translations(data.par.static_text_darkTitleBar.exitCase, this.props.lang.currentLang.lang,
                this.props.lang.translatedData), "icon icon-delete", this.props.owningCase, caseStatusApiData && caseStatusApiData.responseData &&
                caseStatusApiData.responseData.classificationNodes && caseStatusApiData.responseData.classificationNodes[0] &&
              caseStatusApiData.responseData.classificationNodes[0].associations);
            })
        });
      // let heading;
      // const currentCase = this.props.cases[(Object.keys(this.props.cases))[0]];
      // if (Object.keys(this.props.cases).length > 1) {
      //   const noOfCasesExcludingRoot = Object.keys(this.props.cases).length - 1;
      //   heading = `${currentCase.entityName} (+${noOfCasesExcludingRoot} others)`;
      // } else {
      //   heading = currentCase.entityName;
      // }
      // this.props.setDarkTitleBarContent(heading, true, "Exit case", "icon icon-delete", currentCase);
    }
    catch (e) {
    }
  }

  goTOCase = (Urn) => {
    try {
      if (this.state.owningCaseUrn) {
        this.props.history.push({
          pathname: `/case-body/`,
          state: { Urn: this.state.owningCaseUrn }
        });
      }
    }
    catch (e) {
      if (Urn !== undefined) {
        this.props.history.push({
          pathname: `/case-body/`,
          state: { Urn: Urn }
        });
      } else {
        alert("Wrong Case Id");
      }
    }
  }

  listnavigation = (item, key) => {
    return (
      <NavListAccordion lang={this.props.lang.currentLang.lang} navAccHeading={item.entityName !== undefined ? item.entityName : "Other Docs"} key={key} >
        {item.documents.map((child, key) => {
          return (
            <div key={key}>
              <div className="basic-details-title">
                <span>
                  {
                    item.entityName !== undefined
                      ? child.formData.map(item => {
                        if (this.props.lang.currentLang.lang === item.language) {
                          var headerText = item.headerText !== "" && item.headerText !== undefined ? item.headerText : "Note:"
                          return headerText
                        }
                      })
                      : `Note ${key + 1}`
                  }
                </span></div>
              <div className="basic-details-section">
                {
                  child.formData.map(item => {
                    if (this.props.lang.currentLang.lang === item.language) {
                      return item.text
                    }
                  })
                }
              </div>
            </div>
          )
        })}
      </NavListAccordion>);
  }

  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  render() {
    const supportingDocNavigation = (data) => {
      //  const { button_goToCase,page_title_mainTitle ,static_text_supportDocs} = data.par;
      return (
        (this.state.formJson !== undefined ?
          <Fragment><div className="gdoc-welcome-containersupportdocNav gdocs-display-flex">
            <div className="gdoc-left-case-body-container">
              <h2 className="heading">{this.translations(this.state.formJson.par.page_title_mainTitle.pageHeading)}</h2>
              <div className="gdoc-support-dov-banners-area">
                <div className="gdocs-banner msgblue">
                  <i className="icon icon-circle-error-solid msgblue"></i>
                  <span>{this.translations(this.state.formJson.par.notification_warningNotification.message)}</span></div></div>

              <NavListAccordionWrapper>
                {this.state.data.length > 0 ? this.state.data.map((item, key) => this.listnavigation(item, key)) : ""}
              </NavListAccordionWrapper>
            </div>
            <div className="gdoc-right-case-body-container">
              <CaseMenu
                history={this.props.history}
                lang={this.props.lang}
              />
            </div>
          </div>
            <div className="gdoc-supportdoc-footer-btn gdocs-return-to-case-container">
              <button type="button" className="gdocs-btn-primary case-history-btn" onClick={() => this.goTOCase(this.props.Urn)} name="supportingDoc">{this.translations(this.state.formJson.par.button_returnToCase.text)}</button>
            </div>
          </Fragment>
          : ''));

    }

    return supportingDocNavigation(this.props.data);

  }
}

const mapStateToProps = (state) => {
  return {
    cases: state.cases,
    owningCase: electOwningCase(state.cases),
    lang: state.lang
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setDarkTitleBarContent: (...args) => {
      dispatch(setDarkTitleBarContent(...args))
    },
    updateDarkTitleBarCaseStatus: caseStatus => {
      dispatch(updateDarkTitleBarCaseStatus(caseStatus))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SupportingDoc);



// WEBPACK FOOTER //
// ./src/components/CaseBody/SupportingDocuments/SupportingDoc.js